<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title> اضافة بداية كمية كل صنف لكل مخزن</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة </span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_item"
                        :items="items"
                        item-text="name"
                        item-value="id"
                        label="أختر الصنف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_store"
                        :items="stores"
                        item-text="name"
                        item-value="id"
                        label="أختر المخزن"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                      <v-text-field
                        outline
                        v-model="asnaf_q"
                        label="    الكمية   "
                        v-validate="'required'"
                        :error-messages="errors.collect('form2.num_asnaf')"
                        data-vv-name="num_asnaf"
                        data-vv-scope="form2"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="store_items_start"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.item.name }}</td>
          <td class="text-xs-right">{{ props.item.store.name }}</td>
          <td class="text-xs-right">{{ props.item.start }}</td>
          <td class="justify-center layout px-0">
            <v-icon small @click="deleteItem(props.item)">
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  store_items_start,
  add_start_item_quantity,
  delete_start_item_quantity,
  items,
  stores,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "أسم الصنف",
        align: "right",
        value: "name"
      },
      { text: " اسم المخزن", value: "address", align: "right" },
      { text: "  بداية الكمية", value: "address", align: "right" }
    ],
    select_item: { id: "" },
    select_item_edit: { id: "" },
    select_store: { id: "" },
    select_store_edit: { id: "" },
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    store_items_start: [],
    stores: [],
    items: [],
    editedItem: {
      id: "",
      store_id: "",
      item_id: ""
    },
    newItem: {
      store_id: "",
      item_id: ""
    },
    asnaf_q: ""
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.store_items_start.length > 0) {
        return (this.code =
          parseInt(
            this.store_items_start[this.store_items_start.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      items().then(response => {
        this.items = response.data;
      });

      store_items_start().then(response => {
        this.store_items_start = response.data;
        this.pagination.totalItems = response.data.length;
        this.loading = false;
      });

      stores().then(response => {
        this.stores = response.data;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.initialize();
      this.editedIndex = this.store_items_start.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.address = item.address;
      this.editedItem.rasid = item.rasid;
      this.select_item_edit = item.branch;
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.store_items_start.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_start_item_quantity(item.id).then(response => {
            this.loading = false;
            this.store_items_start.splice(index, 1);

            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (
          valid &&
          this.select_item.id != "" &&
          this.select_store.id != "" &&
          this.asnaf_q != ""
        ) {
          this.loading = true;
          this.newItem.item_id = this.select_item.id;
          this.newItem.store_id = this.select_store.id;
          var frmData = new FormData();
          frmData.append("item_id", this.newItem.item_id);
          frmData.append("store_id", this.newItem.store_id);
          frmData.append("asnaf_q", this.asnaf_q);

          add_start_item_quantity(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);

            this.store_items_start.push(response.data);
            this.loading = false;
            this.close();
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
